import React, {ReactNode} from 'react';
import cn from 'classnames';

import HintQuestion from 'shared/ui/Hint/HintQuestion';

import {HintPlacement} from '../../Hint/Hint';

import styles from './LabelWithHint.module.scss';

interface ILabelWithHintProps {
    label: ReactNode,
    hint: string,
    placement?: HintPlacement,
    className?: string,
}

const LabelWithHint: React.FC<ILabelWithHintProps> = ({label, hint, placement = 'top-start', className}) => {
    return (
        <span className={cn(styles.container, className)}>
            {label}
            <HintQuestion placement={placement}>{hint}</HintQuestion>
        </span>
    );
};

export default LabelWithHint;
